// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty[data-v-1e1cfa5a] {\n  display: block;\n  padding: 32px 16px;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 500;\n  color: #999;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
